import React, { Component } from 'react';
import githubImg from "./imgs/github.png";
import linkedInImg from "./imgs/linkedin.png"
import codepenImg from "./imgs/codepen.png"
import { Link, NavLink } from 'react-router-dom';
import "./Navbar.scss";

export default class Navbar extends Component {
    render() {
        return (
            <nav className="sticky-top navbar-expand-sm navbar-dark bg-dark">
                <div className="navbar navbar-light px-5 container-fluid d-flex flex-sm-row flex-column justify-content-between align-items-center">
                    <div className="nameContainer text-center">
                        <Link to="/">
                            <h1 className="name" data-text="Michael" contenteditable>Michael</h1>
                            <h1 className="name" data-text="Lee" contenteditable>Lee</h1>
                        </Link>
                    </div>
                    <div className="d-flex flex-column justify-content-between">
                        <div>
                            <ul className="nav d-flex flex-row justify-content-center">
                                <li className="nav-item mx-5">
                                    <a target="_blank" className="nav-link" href="https://www.linkedin.com/in/michael-lee-460151146/" rel="noreferrer"><img
                                        className="logo" src={linkedInImg} alt="Michael's LinkedIn" /></a>
                                </li>
                                <li className="nav-item mx-5">
                                    <a target="_blank" className="nav-link" href="https://github.com/michaelLeeDeveloper" rel="noreferrer"><img className="logo"
                                        src={githubImg} alt="Michael's GitHub" /></a>
                                </li>
                                <li className="nav-item mx-5">
                                    <a target="_blank" className="nav-link" href="https://codepen.io/michaelleedeveloper/pens/public" rel="noreferrer"><img className="logo codepen"
                                        src={codepenImg} alt="Michael's GitHub" /></a>
                                </li>
                            </ul>
                        </div>

                        <nav>
                            <div class="container-fluid">
                                <button class="navbar-toggler m-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span class="navbar-toggler-icon"></span>
                                </button>
                                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                                        <li className="nav-item mx-5 NavbarLinks">
                                            <NavLink activeClassName="active" to="/About" className="nav-link text-primary">About</NavLink>
                                        </li>
                                        <li className="nav-item mx-5 NavbarLinks">
                                            <NavLink activeClassName="active" to="/Projects" className="nav-link text-primary">Projects</NavLink>
                                        </li>
                                        <li className="nav-item mx-5 NavbarLinks">
                                            <NavLink activeClassName="active" to="/Certifications" className="nav-link text-primary">Certifications</NavLink>
                                        </li>
                                        <li className="nav-item mx-5 NavbarLinks">
                                            <a className="nav-link text-primary" href="./resume.pdf" download="">Resume</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </nav>
        )
    }
}
